var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.finish)?_c('vca-card',[_c('h2',[_vm._v(_vm._s(_vm.$t("deposit.edit.header")))]),_c('DepositEdit')],1):_c('Spinner')
}
var staticRenderFns = []

export { render, staticRenderFns }